export enum ColoredPillTypesEnum {
    SUCCESS = 'success',
    WARNING = 'warning',
    INFO = 'info',
    NEUTRAL = 'neutral',
}
